import { render } from "./ConfigureProfile.vue?vue&type=template&id=47fe3154"
import script from "./ConfigureProfile.vue?vue&type=script&lang=js"
export * from "./ConfigureProfile.vue?vue&type=script&lang=js"

import "./ConfigureProfile.vue?vue&type=style&index=0&id=47fe3154&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__